import { call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { createJobCard, getJobCards, getWorkspaceJobCards, viewJob } from '../utils/requests';
import { createJobCardSuccess, createJobCardFailed, 
  fetchJobCardsSuccess, fetchJobCardsFailed, fetchMyWorkspaceRequest, fetchMyWorkspaceFailed, fetchMyWorkspaceSuccess, viewJobSuccess, viewJobFailed } from '../actions/jobCard';

export function* createJobCardWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.CREATE_JOB_CARD_REQUEST, createJobCardRequestWatcher);
}

export function* fetchJobCardsWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_JOBCARDS_REQUEST, fetchJobCardsRequestWatcher);
}

export function* fetchWorkspaceJobCardsWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.FETCH_MY_WORKSPACE_JOBCARDS_REQUEST, fetchWorkspaceJobCardsRequestWatcher);
}

function* createJobCardRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(createJobCard, payload);

      yield put(createJobCardSuccess(response.data));

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(createJobCardFailed(errorPayload));
    }
}

function* fetchJobCardsRequestWatcher() {
  try {
    const response = yield call(getJobCards);

    yield put(fetchJobCardsSuccess(response.data));
  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    yield put(fetchJobCardsFailed(errorPayload));
  }
  
}

function* fetchWorkspaceJobCardsRequestWatcher() {
  try {
    const response = yield call(getWorkspaceJobCards);

    yield put(fetchMyWorkspaceSuccess(response.data));
  } catch(error) {
    let errorPayload = {};
    if (error.response) {
      errorPayload = error.response.data;
    }
    yield put(fetchMyWorkspaceFailed(errorPayload));
  }
  
}

export function* viewJobWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.VIEW_JOB_REQUEST, viewJobRequestWatcher);
}

function* viewJobRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(viewJob, payload);
      yield put(viewJobSuccess(response.data));
    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(viewJobFailed(errorPayload));
    }
}